import React from 'react';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { removeData } from '../../store/action';
import { connect } from 'react-redux';

const Upload_File = AdminUrls.ADMIN.VIDEOACCESSFILEUPLOAD;

class VideoAccess extends React.Component {
  constructor() {
    super();

    this.state = {
      unauthorized: false,
      file_upload: null,
    };
    this.controller = new AbortController();
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  componentDidMount() {}

  cancelUpload = () => {
    this.setState({ file: '' });
  };

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    if (name === 'file_upload') {
      if (event.target.files.length > 0) {
        this.setState({
          [name]: event.target.files[0],
          file_name: event.target.files[0].name,
        });
      }
    }
  }
  startUpload = () => {
    let blobFile = this.state.file_upload;
    let formData = new FormData();
    formData.append('file', blobFile);

    axios
      .post(Upload_File, formData, {
        processData: false,
        contentType: false,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        NotificationManager.success(
          'Success!',
          'MyCPD Record Created Successfully'
        );
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  };

  render() {
    return (
      <div className="form-inline">
        <div className="shadow">
          <div className="row">
            <div className="col-md-4">
              <button type="button" className="btn btn-success w-100" style={{ padding: '0' }}>
                <label className='add-cvs-file'>
                  <span><i className="glyphicon glyphicon-plus"></i></span>
                  <span>Add csv file</span>
                  <input
                    id="file_upload"
                    type="file"
                    name="file_upload"
                    className="hidden"
                    value={this.state.file}
                    onChange={this.handleInputChange}
                  />
                </label>
              </button>
            </div>
            <div className="col-md-8">
              <button
                type="button"
                className="btn btn-primary start"
                onClick={this.startUpload}
              >
                <i className="glyphicon glyphicon-upload"></i>
                <span>Start upload</span>
              </button>
              <button
                type="reset"
                className="btn btn-warning cancel"
                onClick={this.cancelUpload}
              >
                <i className="glyphicon glyphicon-ban-circle"></i>
                <span>Cancel upload</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(VideoAccess);
